import React, { useState, useEffect, useContext } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../../components/MaterialDataGrid'
import MaterialTypography from '../../../components/MaterialTypography'
import { AppBar, Badge, Card, CardHeader, Stack, styled, Tab, Tabs } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../../Utils/Baseurl';
import axios from 'axios';
import MaterialBox from '../../../components/MaterialBox'
import breakpoints from '../../../assest/theme/base/breakpoints'
import UserDetailsContext from '../../../context/auth'

//CSS for material UI Badge
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -1,
        top: -6,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

function Approvals() {

    const navigate = useNavigate()
    const { user } = useContext(UserDetailsContext);

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })
    const [userDetails, setUserDetails] = useState({
        department: "",
        designation: "",
        employeeType: ""
    });

    const [tabsOrientation, setTabsOrientation] = useState("horizontal"); 
    const [tabValue, setTabValue] = useState(0); 

    const [employeeList, setEmployeeList] = useState([])

    useEffect(() => {
        fetchData()
    }, []);

    const fetchData = async () => {
        const query = `
            query RequestRegularizationTeamAll($id: String!) {
                requestRegularizationTeamAll(id: $id) {
                    id
                    checkIn
                    checkOut
                    reason
                    status
                    lastUpdate
                    requestedDate
                    hrApproval
                    teamApproval
                    teamleaderId   
                }
            }
        `;
        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: query,
                    variables: {
                        id: "Q3VzdG9tVXNlclZpZXc6Ng==" 
                    }
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
          
            console.log('response:',response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    

    useEffect(() => {
        
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }
      
        window.addEventListener("resize", handleTabsOrientation);
        handleTabsOrientation();
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    function notificationsLabel(badgeContent) {
        if (badgeContent === 0) {
            return 'no notifications';
        }
        if (badgeContent > 99) {
            return 'more than 99 notifications';
        }
        return `${badgeContent} notifications`;
    }

    const employeeListTable = {
        columns: [
            {
                field: "empid",
                headerName: "Employee Id",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "firstName",
                headerName: "Employee Name",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "contactNumber",
                headerName: "Requested Date",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "department",
                headerName: "Check In",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "designation",
                headerName: "Check Out",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "teamleader",
                headerName: "Reason",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "employeeType",
                headerName: "Status",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
        ],
    }

    const handleNewEmployee = () => {
        navigate('/employee-management/add-employee')
    }

    const onEmployeeListClick = (e) => {
        console.log('eeeee:',e);
        
        console.log('onEmployeeListClick:', e?.id, e)
        if (e?.id) {
            // navigate(`/employee-management/viewscreen?id=${e?.id}`)
            navigate(`/employee-management/add-employee?id=${e?.id}`)
        }
    }


 

    const handleSetTabValue = (event, newValue) => {
        setTabValue(newValue)
    }
  return (
    <DashboardLayout>
    <Card>
        <CardHeader title={(
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                    Regularization Approval
                    </MaterialTypography>
                   
                </Stack>

                {/* <MaterialBox display="flex" justifyContent={{ md: "flex-end" }} alignItems="center" width="60%">
                    <MaterialBox width="80%">
                        <AppBar position="static" >
                            <Tabs
                                orientation={tabsOrientation}
                                value={tabValue}
                                onChange={handleSetTabValue}
                                sx={{ backgroundColor: "transparent" }}
                            >
                                {tabs.map(tab => (
                                    <Tab label={tab.name} icon={<StyledBadge badgeContent={tab.count} color="error" />} iconPosition="end"
                                    />
                                ))}
                            </Tabs>
                        </AppBar>
                    </MaterialBox>
                </MaterialBox> */}

                {/* <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEmployee()}
                >
                    Employee
                </MaterialButton> */}
            </Stack>
        )} />
        <MaterialDataGrid
            // customHeight={550}
            rows={employeeList}
            columns={employeeListTable.columns}
            checkboxSelection={false}
            isSelectable={true}
            onRowClick={onEmployeeListClick}
            loading={pageState.loading}
            localeText={{
                noRowsLabel: (
                    <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                        <MaterialTypography variant="body2" fontWeight="medium" color="text">
                            No employee found
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            You have not yet add any employee details. Click on the "Add Employee" button to start adding employee details.
                        </MaterialTypography>
                    </Stack>
                )
            }}
        />
    </Card>
</DashboardLayout>
  )
}

export default Approvals